import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../../../../components/antd/card/CardContent";
import { CardTitle } from "../../../../../components/antd/card/CardTitle";
import { v4 as uuidv4 } from "uuid";
import { useCpFormValue } from "../../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../../../gvc/testNewForm/CpInput";
import { CpArrayObject } from "../../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../../../../workload/draft/CpArrayItemNameValuePair";
import { CpArrayItemTaint } from "../aws/CpArrayItemTaint";
import { CpErrorWarningArrayIcon } from "../../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { NodePoolDetectedTags } from "../detectedTags";
import { NodePoolCoreButton } from "../nodePoolCoreButton";

interface Props {
  index: number;
}
export const EphemeralNodePool: React.FC<Props> = ({ index }) => {
  const name = useCpFormValue(`ephemeral.nodePools.${index}.name`);

  return (
    <div className="cpln-form-section cpln-ant-tab-content">
      <Card>
        <CardTitle>
          Node Pool{name ? ` | ${name}` : ""}
          <CpErrorWarningArrayIcon names={[`ephemeral.nodePools`]} />
        </CardTitle>
        <CardContent>
          <div>
            <NodePoolDetectedTags name={`ephemeral.nodePools.${index}.labels`} />
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.name`}>Name</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.name`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.name`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.count`}>Count</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.count`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.count`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.arch`}>Arch</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.arch`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.arch`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.flavor`}>Flavor</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.flavor`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.flavor`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.cpu`}>CPU</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.cpu`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.cpu`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`ephemeral.nodePools.${index}.memory`}>Memory</CpLabel>
              <CpInput name={`ephemeral.nodePools.${index}.memory`} style={{ maxWidth: 450 }} />
              <CpErrorWarning name={`ephemeral.nodePools.${index}.memory`} />
            </CpFormItem>
            <div style={{ maxWidth: 900 }}>
              <CpFormItem>
                <div className="flex items-center gap-4">
                  <CpLabel name={`skip`}>Labels</CpLabel>
                  <NodePoolCoreButton name={`ephemeral.nodePools.${index}.labels`} />
                </div>
                <div className="-mt-2">
                  <CpArrayObject
                    factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
                    labels={["Name", "Value"]}
                    name={`ephemeral.nodePools.${index}.labels`}
                  >
                    <CpArrayItemNameValuePair />
                  </CpArrayObject>
                </div>
              </CpFormItem>
            </div>
            <div style={{ maxWidth: 900 }}>
              <CpArrayObject
                factoryFn={() => ({ id: uuidv4(), key: "", value: "", effect: "" })}
                labels={["Key", "Value", "Effect"]}
                label="Taints"
                name={`ephemeral.nodePools.${index}.taints`}
              >
                <CpArrayItemTaint />
              </CpArrayObject>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
